(function () {
'use strict';

angular
    .module('actionPlanEditRoutes', [
        'actionPlanEditModule'
    ])
    .config(router);

    router.$inject = ['$stateProvider', 'historyCtxtServiceProvider'];

    function router($stateProvider, historyCtxtServiceProvider) {
        $stateProvider

            // Action Plan
            .state('recommendation.edit.actionPlan', {
                abstract: true,
                url: '/ActionPlan',
                data: {
                    // Prevents this view from showing any breadcrumb element
                    breadcrumb: null
                }
            })

            // Action Plan - Add
            .state('recommendation.edit.actionPlan.add', {
                url: '/Add',
                resolve: {
                    actionPlan: ['recommendation', 'grcActionPlanService', function (recommendation, service) {
                        return service.getActionPlansByRecommendation(recommendation.RecommendationID).then(function () {
                            return {
                                RecommendationID: recommendation.RecommendationID
                            }
                        });
                    }],
                    actionPlanCriterias: function () {
                        return [];
                    }
                },
                views: {
                    'mainContent@recommendation': {
                        templateUrl: require('./actionPlanEdit.tpl.html'),
                        controller: 'ActionPlanEditController'
                    }
                }
            })

            // Action Plan - Edit
            .state('recommendation.edit.actionPlan.edit', {
                url: '/{ActionPlanID:int}',
                data: {
                    breadcrumb: {
                        titlePath: 'actionPlan.TitleEN',
                        cssIcon: 'fa fa-cogs'
                    }
                },
                params: historyCtxtServiceProvider.getStateParamsConfig(),
                resolve: {
                    actionPlan: ['$stateParams', 'grcActionPlanService', function ($stateParams, service) {
                        return service.getActionPlan($stateParams.ActionPlanID);
                    }],
                    actionPlanCriterias: ['$stateParams', 'grcActionPlanCriteriaService', function ($stateParams, service) {
                        return service.getActionPlanCriteriasByActionPlan($stateParams.ActionPlanID);
                    }]
                },
                views: {
                    'mainContent@recommendation': {
                        templateUrl: require('./actionPlanEdit.tpl.html'),
                        controller: 'ActionPlanEditController'
                    }
                }
            });
    }
})();